import React from 'react';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import {StylesProvider} from '@material-ui/core/styles';
import {Helmet} from 'react-helmet';
import Header from '../components/shared/Header';
import {Container, createMuiTheme, MuiThemeProvider} from '@material-ui/core';
import styled from 'styled-components';
import Routes from '../Routes';
import {blue, deepOrange} from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: deepOrange,
  },
});

const StyledContainer = styled(Container)`
margin-top: 20px;
`;

const App = () => {
  if (process.env.NODE_ENV === 'production') {
    const scriptText = `
          (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
          'gtm.start':
          new Date().getTime(), event: 'gtm.js',
        });
          var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-N7N5NLG');
        `;

    const tagManager = document.createElement('script');
    tagManager.text = scriptText;
    document.head.appendChild(tagManager);
  }

  return (
      <MuiThemeProvider theme={theme}>

        <StylesProvider injectFirst>

          <Helmet>
            <title>VladLink NPS</title>
            <meta name="description"
                  content="Компания «Владлинк» — один из крупнейших
                  Телеком-операторов во Владивостоке, Уссурийске, Артеме, Арсеньеве,
                  Находке, Фокино и Большом Камне. Подключаем быстрый домашний интернет и цифровое телевидение!"
            />
          </Helmet>
          <Header/>

          <StyledContainer>
            <Router>
              <Routes/>
            </Router>
          </StyledContainer>
        </StylesProvider>

      </MuiThemeProvider>
  );
};

export default App;
